<template>
  <div class="z-100">
    <div v-if="!uriData" class="pt-20">
      <p class="text-lg text-center mb-1">{{ t('welcomeTitle') }}</p>
      <p class="text-center mb-3">{{ t('urlInvalid') }}</p>
    </div>
    <div v-else>
      <div v-if="loading">
        <div class="flex justify-center mb-5 pt-20">
          <custom-loader class="" color="#888" size="50px"></custom-loader>
        </div>
        <p class="text-center mb-3">{{ t('checkingInfo') }}</p>
      </div>
      <div v-else class="grid grid-cols-1 2xl:gap-5 w-full 2xl:w-1/2 mx-auto">
        <vc-presentation :verifiableCredential="vpDetail"></vc-presentation>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject } from 'vue';
import { useRoute } from 'vue-router';
import { detectLang, currentLang, t } from '../locales/index.js';

export default {
  setup() {
    const route = useRoute();
    const utils = inject('utils');
    const api = inject('api');
    const vpDetail = ref(null);
    const loading = ref(false);
    const uriData = ref(null);

    currentLang.value = detectLang();

    if (route?.query?.data) {
      uriData.value = decodeURIComponent(route.query.data);
    } else if (route?.query?.uri) {
      const uri = decodeURIComponent(route.query.uri);
      const match = uri.match(/[?&]data=([^&]+)/);
      if (match) {
        uriData.value = decodeURIComponent(match[1]);
      }
    }

    if (uriData.value) {
      loading.value = true;

      const dataArray = uriData.value.split('&');
      const dataObject = {};
      dataArray.forEach((item) => {
        const [key, value] = item.split('=');
        dataObject[key] = value;
      });
      const vpRequest = JSON.parse(Object.keys(dataObject)[0]);
      const templateHash = vpRequest.context.find(
        (item) => item.type === 'templateHash'
      ).value;

      utils.getTemplateData(templateHash).then((data) => {
        api.getIssuerDetailsLinkFromCode(data.issuerDID).then((res) => {
          const profileIpfsUrl = res.data.service[0]?.serviceEndpoint;

          utils.getJsonDataFromUrl(profileIpfsUrl).then((issuerProfile) => {
            api.getDynamicLink(route.query.uri).then((res) => {
              vpDetail.value = {
                ...data,
                dynamicLink: res.data.dynamicLink,
                type: data.badgeCategory,
                issuer: {
                  ...issuerProfile,
                },
                raw: data,
              };
              loading.value = false;
            });
          });
        });
      });
    }

    return { vpDetail, loading, uriData, t };
  },
};
</script>
